import Name from './Name';

export default abstract class AbstractUser {
    private readonly _id: string;
    private readonly _name: Name;
    private readonly _links: object;
    private readonly _email: string;
    private readonly _photo: object|null;

    constructor({
        id,
        name,
        photo,
        links,
        email,
    }) {
        this._id = id;
        this._name = new Name(name);
        this._links = links;
        this._photo = photo;
        this._email = email;
    }

    get id(): string {
        return this._id;
    }

    get name(): Name {
      return this._name;
    }

    get links(): object {
        return this._links;
    }

    get photo(): object | null {
      return this._photo;
    }

    get email(): string {
      return this._email;
    }

    abstract get role(): string;
}
